import React from 'react'
import { QuizResults } from '../../contexts/quizContext'
import {
  Category,
  CategoryFeature,
  category_info,
  isHiddenCategory,
} from '../../data/features'
import { podcast_cover_content } from '../../data/questions'
import confetti from '../../images/confetti.gif'
import { divId, toTitleCase } from '../../utils/functions'
import { O, T } from '../../utils/Typography'
import ImageWithLoading from '../ImageWithLoading/ImageWithLoading'

const EDGE = 100
const PADDING = 5

type CategoryInfoProps = {
  category: Category
  feature: CategoryFeature
  quizResults: QuizResults
}

const CategoryInfo: React.FC<CategoryInfoProps> = ({
  category,
  feature,
  quizResults,
}) => {
  const [chosenFeature, setChosenFeature] = React.useState<string>(feature)

  const [highlightedFeature, setHighlightedFeature] = React.useState<string>(
    feature,
  )
  // const [selectionBoxPos, setSelectionBoxPos] = React.useState<
  //   [number, number]
  // >([0, 0])

  // const selectedFeatureRef = React.useRef<HTMLDivElement>(null)
  const [originalEl, setOriginalEl] = React.useState<null | HTMLDivElement>(
    null,
  )
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLDivElement>(null)

  // const artTheoryName = getFeatureOnly(podcastGenre)

  //   const selectedFeatureRef = React.useCallback(node => {
  //     if (node) setAnchorEl(node) // a side effect!
  //  }, [])

  React.useEffect(() => {
    setHighlightedFeature(feature)
  }, [feature])

  React.useEffect(() => {
    setChosenFeature(feature)
  }, [feature])

  React.useEffect(() => {
    setAnchorEl(originalEl)
  }, [originalEl])

  // React.useEffect(() => {
  //   if (!anchorEl) return
  //   const { offsetTop, offsetLeft } = anchorEl
  //   // console.log('anchorEl', anchorEl)
  // }, [anchorEl])

  // React.useLayoutEffect(() => {
  //   setAnchorEl(selectedFeatureRef.current)
  // }, [selectedFeatureRef])

  // console.log(`CategoryInfo received: ${podcastGenre}`)

  const category_details = category_info[category]
  if (isHiddenCategory(category_details)) {
    return null
  }

  const feature_options_dict = category_details.features
  const chosen_feature_details = feature_options_dict[highlightedFeature]

  // if (!feature_details) {
  //   throw new Error()
  // }

  const {
    post_script,
    type,
    cover_image,
    title: category_detail_title,
  } = category_details
  const { title: feature_detail_title, header, body, note } =
    chosen_feature_details ?? {}

  const category_title =
    category_detail_title ?? toTitleCase(category.replaceAll('_', ' '))
  const feature_title =
    feature_detail_title ?? toTitleCase(highlightedFeature.replaceAll('_', ' '))

  return (
    <div
      className='Results-feature-container'
      id={divId(category)}
      style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }}>
      <img src={cover_image} alt={category_title} style={{ width: '100%' }} />
      {/* <T variant='h1' style={{ fontFamily: 'Viva-Beautiful' }}>
        Your {category_title}
      </T> */}
      <div style={{ height: 20 }} />

      <T
        variant='h3'
        className='Results-info-title'
        style={{ fontFamily: 'Poppins', fontWeight: '900' }}>
        <O>{feature_title}</O>
      </T>
      <br />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          position: 'relative',
        }}>
        {Object.entries(feature_options_dict)
          // Make sure that the requirements to display are filled
          .filter(([_, feature_detail]) => {
            if (feature_detail?.requires === undefined) return true

            const [required_category, required_feature] =
              feature_detail.requires.split('>') ?? []
            return quizResults[required_category] === required_feature
          })
          .map(([feature_option, feature_detail]) => (
            <div
              ref={(element) => {
                if (feature_option === chosenFeature) {
                  setOriginalEl(element)
                }
              }}
              style={{
                position: 'relative',
                padding: PADDING,
                cursor: 'pointer',
                fontWeight:
                  feature_option === highlightedFeature ? 'bold' : 'normal',
              }}
              onMouseEnter={(event) => {
                setAnchorEl(event.currentTarget)
                setHighlightedFeature(feature_option)
              }}
              onMouseLeave={() => {
                setAnchorEl(originalEl)
                setHighlightedFeature(chosenFeature)
              }}
              onClick={() => {
                setChosenFeature(feature_option)
              }}
              key={feature_option}>
              <div
                style={{
                  position: 'relative',
                  backgroundColor: '#10b1b1',
                  opacity: chosenFeature === feature_option ? 1 : 0.6,
                  color: 'white',
                  width: EDGE,
                  height: EDGE,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box',
                  borderRadius:
                    category_details?.feature_image_type === 'circle' ? 99 : 0,
                  lineBreak: 'anywhere',
                }}>
                {feature_detail?.image ? (
                  <img
                    src={feature_detail.image}
                    alt={feature_option}
                    style={{ width: '100%' }}
                  />
                ) : (
                  <div style={{ margin: 5 }}>
                    <T variant='body2'>
                      <b>
                        {/* <b style={{ fontSize: 14 }}> */}
                        {toTitleCase(feature_option.replaceAll('_', ' '))}
                        {/* </b> */}
                      </b>
                    </T>
                  </div>
                )}
              </div>
              {feature === feature_option && (
                <img
                  src={confetti}
                  alt={'confetti'}
                  style={{
                    position: 'absolute',
                    top: 0,
                    width: EDGE,
                    height: EDGE,
                  }}
                />
              )}
            </div>
          ))}
        {/* 10b1b1 */}

        <div
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            left: anchorEl?.offsetLeft,
            top: anchorEl?.offsetTop,
            width: EDGE,
            height: EDGE,
            borderColor: '#d9559d',
            borderWidth: PADDING,
            borderStyle: 'solid',
            borderRadius:
              category_details?.feature_image_type === 'circle' ? 99 : 0,
            transition: 'all 0.25s ease-in-out',
          }}
        />
      </div>

      <br />
      {/* <T variant='h6' className='Results-info-title'>
        Your {category_title}:
      </T> */}

      {header && (
        <>
          <br />
          <T style={{ fontSize: '1.2rem' }}>
            <b>{header}</b>
          </T>
        </>
      )}
      {body && (
        <>
          <br />
          <T style={{ fontSize: '1.2rem' }}>{body}</T>
        </>
      )}
      {note && (
        <>
          <br />
          <T style={{ fontSize: '1.2rem' }}>
            <i>{note}</i>
          </T>
        </>
      )}

      {post_script && (
        <>
          <br />
          <br />
          <T style={{ paddingTop: 0, fontSize: '1rem' }}>{post_script}</T>
        </>
      )}

      {type === 'show_images' && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            marginTop: 40,
          }}>
          {podcast_cover_content
            .filter(
              (item) =>
                Object.entries(item.features).filter(
                  ([key, value]) =>
                    (value ?? 0) > 0 &&
                    key.split('>')[1] === highlightedFeature,
                ).length,
            )
            .map((item, idx) => (
              <ImageWithLoading
                key={idx}
                src={item.content}
                style={{
                  width: '100%',
                  borderRadius: '8px',
                  height: 200,
                  objectFit: 'contain',
                  paddingRight: 10,
                  paddingBottom: 10,
                }}
              />
            ))}
        </div>
      )}
    </div>
  )
}

export default CategoryInfo
